import { createEnum } from "./utils";

const MODAL_ID = {
  ADD_ROLE: "add-role",
  CONFIRM_DELETE: "confirm-delete-done",
  DEACTIVATE_USER: "deactivate-user",
  REMOVE_MANAGER: "remove-manager",
  TEAM_LIST: "team list",
  MANAGER_LIST: "manager list",
  EMG_FIELD: "emergency field",
  EDU_FIELD: "education field",
  DELETE_CUSTOMER: "delete customer",
  MYTEAM_LIST: "myteam list",
  TIMELINE_MODAL: "timeline modal",
  VIEW_LOCATION: "view location",
  STATUS_LIST: "status list",
  ADD_CUSTOMER: "add customer",
  DEFAULT: "default",
  ACTIONPOINT: "action point",
  EDITCUSTOMER: "edit customer",
  BULK_ASSIGN: "bulk assign",
  EXPENSE: "expense claim",
  REJECT_CLAIM: "reject claim",
  EXPENSE_MY_CLAIM: "my claim",
  EXPENSE_VIEWLOG: "view log",
  EXPENSE_ADD_CLAIM: "add claim",
  EXPENSE_DECLINE: "decline cliams",
  EXPENSE_ADD_CATEGORY: "add category",
  EXPENSE_EDIT_CATEGORY: "edit category",
  EXPENSE_DELETE_CATEGORY: "delete category",
  EXPENSE_REVIWER: "expense reviewer",
  EXPENSE_APPROVER: "expense approver",
  EXPENSE_SET_APPROVER: "expense set approver",
  EXPENSE_APPROVER_FILER: "expense approver filter",
  COMPANY_SETTING_TIMEZONE: "company setting timezone",
  COMPANY_SETTING_CURRENCY: "company setting currency",
  COMPANY_DELETE_CONFIRM: "company delete confirm",
  TASK_SETTING: "task setting",
  TERRITORY_MASTER: "territory master add",
  ORGANIZATIONAL_DEPARTMENT: "organizational department",
  ORGANIZATIONAL_DESIGNATION: "organizational designation",
  ORGANIZATIONAL_BRANCHES: "organizational branches",
  SUMMARIZE_TIMELINE: "timeline summary",
  REFERRAL_BUSINESS: "referral business",
  VIEW_REFERRAL_BUSINESS: "view referral business",
  INACTIVE_USER: "inactive user",
  IDENTITY_FIELD: "identity field",
};
createEnum(MODAL_ID);

export { MODAL_ID };

export const ORDER_STATUS_LIST = [
  { id: 1, label: "Pending" },
  { id: 2, label: "Accept / Processing" },
  { id: 3, label: "Reject / Cancel" },
  { id: 4, label: "Partial Complete" },
  { id: 5, label: "Complete" },
  { id: 6, label: "Partial Shipped" },
  { id: 7, label: "Shipped" },
  { id: 8, label: "Partial Delivered" },
  { id: 9, label: "Delivered" },
  { id: 10, label: "Closed" },
];

export const STATUS_TRANSITIONS_DETAIL: Record<number, number[] | null> = {
  1: [3, 4, 5, 6, 7, 8, 10], // Pending → Processing ---
  2: [3, 4, 5, 6, 7, 8, 9, 10], // Processing → Complete ---
  3: null, // Reject → no dropdown
  4: [5, 6, 7, 8, 9, 10], // Partial Complete → Complete
  5: [6, 7, 8, 9, 10], // Complete → Shipped, Delivered, Closed ---
  6: [7, 8, 9, 10], // Partial Shipped → Delivered, Closed ---
  7: [8, 9, 10], // Shipped → Delivered, Closed ---
  8: [9, 10], // Partial Delivered → Delivered, Closed
  9: [10], // Delivered → Closed
  10: null, // Closed → no dropdown
};

export const STATUS_TRANSITIONS: Record<number, number[] | null> = {
  1: [2], // Pending → Processing
  2: [3, 5, 7, 9, 10], // Processing → Complete
  3: null, // Reject → no dropdown
  4: [7, 9, 10], // Partial Complete → Complete
  5: [7, 9, 10], // Complete → Shipped, Delivered, Closed
  6: [9, 10], // Partial Shipped → Delivered, Closed
  7: [9, 10], // Shipped → Delivered, Closed
  8: [10], // Partial Delivered → Delivered, Closed
  9: [10], // Delivered → Closed
  10: null, // Closed → no dropdown
};

export const ORDER_STATUS = [
  { StatusId: 1, Status: "Pending" },
  { StatusId: 2, Status: "Accept / Processing" },
  { StatusId: 3, Status: "Reject / Cancel" },
  { StatusId: 4, Status: "Partial Complete" },
  { StatusId: 5, Status: "Complete" },
  { StatusId: 6, Status: "Partial Shipped" },
  { StatusId: 7, Status: "Shipped" },
  { StatusId: 8, Status: "Partial Delivered" },
  { StatusId: 9, Status: "Delivered" },
  { StatusId: 10, Status: "Closed" },
];

export const EXPENSE_STATUS = [
  { StatusId: 1, Status: "Pending" },
  { StatusId: 2, Status: "Approved" },
  { StatusId: 3, Status: "Partially Approved" },
  { StatusId: 4, Status: "Rejected" },
  { StatusId: 5, Status: "Pending Reimbursement" },
  { StatusId: 6, Status: "Reimbursed" },
];

export const numberOfLeaves = [
  { value: 0, label: "0" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
];

export const hours = [
  "4:00", "4:15", "4:30", "4:45",
  "5:00", "5:15", "5:30", "5:45",
  "6:00", "6:15", "6:30", "6:45",
  "7:00", "7:15", "7:30", "7:45",
  "8:00", "8:15", "8:30", "8:45",
  "9:00", "9:15", "9:30", "9:45",
  "10:00", "10:15", "10:30", "10:45",
  "11:00", "11:15", "11:30", "11:45",
].map((hour) => ({
  value: hour,
  label: hour,
}));

export const daysOfWeek = [
  { value: "Sunday", label: "Sunday" },
  { value: "Monday", label: "Monday" },
  { value: "Tuesday", label: "Tuesday" },
  { value: "Wednesday", label: "Wednesday" },
  { value: "Thursday", label: "Thursday" },
  { value: "Friday", label: "Friday" },
  { value: "Saturday", label: "Saturday" },
];

export const alternateOff = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
];

export const excelFormat = [
  { value: "format1", label: "Format 1" },
  { value: "format2", label: "Format 2" },
];

export const claimStatus = [
  { StatusId: 1, Status: "Pending" },
  { StatusId: 2, Status: "Approved" },
  { StatusId: 3, Status: "Rejected" },
];

export const leadStatusList = [
  { StatusId: "TouchedLeads", Status: "Touched Leads" },
  { StatusId: "UnTouchedLeads", Status: "Untouched Leads" },
  { StatusId: "LeadsWithoutDeals", Status: "No Deals" },
  { StatusId: "LeadsWithoutTasks", Status: "No Tasks" },
  { StatusId: "LeadsWithoutOrders", Status: "No Orders" },
  { StatusId: "LeadsWithoutCalls", Status: "No Calls" },
  { StatusId: "LeadsWithoutVisits", Status: "No Visits" },
];

export const PUNCH_STATUS = [
  { value: "punched_in", label: "Punched In" },
  { value: "punched_out", label: "Punched Out" },
  { value: "not_punched_in", label: "Not Punched In" },
];


export const Activity = [
  { StatusId: "CallLog", Status: "Call Log" },
  { StatusId: "QuickTask", Status: "Quick Task" },
  { StatusId: "Appointment", Status: "Appointment" },
];
